import axios from 'axios'
import { beforeRequestError, beforeRequestSuccessWithoutRequestIdHeader, onError, onSuccess } from '../interceptors'
import env from '../../public/env.json'
import getConfig from '../../utils/config'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'
const config = getConfig(env.environment)

const proxyClient = axios.create({
  baseURL: config.userapiMajorityUrl,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

proxyClient.interceptors.request.use(beforeRequestSuccessWithoutRequestIdHeader, beforeRequestError)

proxyClient.interceptors.response.use(onSuccess, onError('User API'))

export const client = proxyClient
